module.exports = __webpack_public_path__ + "img/2.4_Students-Trainees_1_Harrison.4bbf80d52e847ecd9d2cb73e3a0c52c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.4_Students-Trainees_1_Harrison.png
// module id = 763
// module chunks = 0